package com.macrofocus.high_d

import com.macrofocus.high_d.distributions.DefaultDistributionsController
import com.macrofocus.high_d.distributions.DefaultDistributionsView
import com.macrofocus.high_d.distributions.DistributionsModel
import react.FC
import react.Props

@JsExport
external interface DistributionsProps : Props {
    var model: DistributionsModel<Int, String, Any?, Any?>?
}

@JsExport
val Distributions = FC<DistributionsProps> { props ->
//    val view = useMemo(props.model) {
        val view = DefaultDistributionsView<Int, String, Any?, Any?>()
        view.model = props.model
        DefaultDistributionsController<Int, String, Any?, Any?>(view)
        view
//    }
    view.component.nativeComponent()
}
